import Axios from 'axios';

const API_URL_V3 = process.env.API_URL + "/api/v3/data/addresses/";

class Kota {
  index(province_id) {
    return Axios.get(API_URL_V3 + `cities?province_id=${province_id}&order_column=name&order_direction=asc`);
  }

  show(city_id) {
    return Axios.get(API_URL_V3 + `cities/${city_id}`);
  }
}

export default new Kota();



// WEBPACK FOOTER //
// ./src/api/daerahindonesia/kota.js